<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <div>
    <template v-if="loading">
      <div
        class="pa-4 d-flex align-center justify-center"
        style="width: 100%"
      >
        <v-progress-circular
          indeterminate
          size="24"
        />
      </div>
    </template>
    <template
      v-else
    >
      <v-btn
        :dark="isDarkMode"
        :light="!isDarkMode"
        color="transparent"
        elevation="0"
        icon
        @click="naVDialogOpen = true; activeItem = null;"
      >
        <v-icon
          color="black"
          size="25"
        >
          mdi-menu
        </v-icon>
      </v-btn>
    </template>
    <v-expand-x-transition>
      <div
        v-if="naVDialogOpen"
        id="navDialogContainer"
        class="white elevation-0 py-2 px-3"
      >
        <v-btn
          :dark="isDarkMode"
          :light="!isDarkMode"
          class="pa-0 ml-1"
          color="transparent"
          elevation="0"
          icon
          @click="naVDialogOpen = false; activeItem = null;"
        >
          <v-icon
            color="black"
            size="24"
          >
            mdi-menu-open
          </v-icon>
        </v-btn>
        <v-slide-x-reverse-transition
          hide-on-leave
          leave-absolute
        >
          <div
            v-if="naVSubDialogOpen"
            id="navSubDialogContainer"
            class="py-2 px-3 pt-0"
          >
            <v-btn
              :dark="isDarkMode"
              :light="!isDarkMode"
              class="backBtn mb-0"
              color="transparent"
              elevation="0"
              height="48px"
              style="color: black; text-transform: unset;"
              width="100%"
              @click="naVDialogOpen = true;naVSubDialogOpen = false; activeItem = null"
            >
              <v-icon
                class="pl-3"
                color="black"
                size="24"
              >
                mdi-arrow-left
              </v-icon>
              <div class="pl-3">
                Main menu
              </div>
            </v-btn>
            <div
              v-dragscroll
              style="overflow: hidden;height: 85vh"
            >
              <template v-for="(firstItem,i) in activeItem.children">
                <template v-if="firstItem.children">
                  <v-list-group
                    :key="'firstItem'+i"
                    append-icon="mdi-menu-down"

                    class="listItemStyle ml-auto mr-0"
                    color="grey darken-3"
                    style="width: 90% !important;"
                  >
                    <template
                      #activator
                    >
                      <v-list-item-title
                        style="font-size: 12px !important;"
                      >
                        {{ $t(firstItem.title) }}
                      </v-list-item-title>
                    </template>

                    <template v-for="(secondItem,j) in firstItem.children">
                      <template v-if="secondItem.children">
                        <v-list-group
                          :key="'second'+j"
                          no-action
                          sub-group
                        >
                          <template #activator>
                            <v-list-item>
                              <v-list-item-title
                                :class="secondItem.title"
                                class="listItemStyle ml-auto mr-0"
                                style="font-size: 12px !important; width: 90% !important;"
                              >
                                {{ $t(secondItem.title) }}
                              </v-list-item-title>
                            </v-list-item>
                          </template>
                          <navigation-list-item
                            v-for="(thirdItem,k) in secondItem.children"
                            :key="'third'+k"
                            :active="$route.path === activeItem.group + '/' + thirdItem.to"
                            :class="thirdItem.title"
                            :loading="thirdItem.loading"
                            :locked="thirdItem.locked"
                            :sub-btn="true"
                            :title="thirdItem.title"
                            @click="goto(thirdItem,secondItem.group)"
                          />
                        </v-list-group>
                      </template>

                      <template v-else>
                        <navigation-list-item
                          :key="'second'+j"
                          :active="$route.path === activeItem.group + '/' + secondItem.to"
                          :class="secondItem.title"
                          :loading="secondItem.loading"
                          :locked="secondItem.locked"
                          :sub-btn="true"
                          :title="secondItem.title"
                          @click="goto(secondItem,firstItem.group)"
                        />
                      </template>
                    </template>
                  </v-list-group>
                </template>
                <template v-else>
                  <navigation-list-item
                    :key="'firstMenu'+i"
                    :active="$route.path === activeItem.group + '/' + firstItem.to"
                    :class="firstItem.title"
                    :loading="firstItem.loading"
                    :locked="firstItem.locked"
                    :sub-btn="true"
                    :title="firstItem.title"
                    @click="goto(firstItem,activeItem.group);"
                  />
                </template>
              </template>
            </div>
          </div>
        </v-slide-x-reverse-transition>
        <v-slide-x-transition
          hide-on-leave
          leave-absolute
        >
          <div v-if="!naVSubDialogOpen">
            <transition-group>
              <navigation-item
                v-for="categories in navItems"
                :key="categories.title"
                :active="$route.path.includes(categories.group)"
                :class="categories.title"
                :icon="categories.icon"
                :icon-fx="categories.iconFx"
                :level="categories.children ? 1 : 0"
                :locked="categories.locked"
                :title="categories.title"
                @click="categories.children.length === 1 && !categories.locked ? goto(categories.children[0], categories.group) : activeCurrentNavBarItem(categories,false)"
              />
            </transition-group>
          </div>
        </v-slide-x-transition>
      </div>
    </v-expand-x-transition>
    <div
      id="shadowRoot"
      :style="naVDialogOpen ? 'opacity: 1; pointer-events: all; visibility: visible;' : ''"
      @click="resetDialog"
    />
  </div>
</template>

<script>
import { productActivatePage, productIsReadyForStore, restaurantMenu } from '@/views/AppIndex/navigation'
import { mapMutations } from 'vuex'
import NavigationItem from '@/views/AppIndex/Widget/NavigationItem.vue'
import NavigationListItem from '@/views/AppIndex/Widget/NavigationListItem.vue'
import { getActiveProductCode } from '@/model/dataLayer/api/SaaS/user'
import { changeLanguage, Remember } from '@/model/global/GlobalSettings'
import { dragscroll } from 'vue-dragscroll/src/main'

export default {
  name: 'NavigationItems',
  components: {
    NavigationListItem,
    NavigationItem
  },
  directives: {
    dragscroll
  },
  props: {
    isDarkMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeItem: null,
      naVDialogOpen: false,
      naVSubDialogOpen: false,
      navItems: restaurantMenu,
      loading: true
    }
  },
  computed: {
    currentLocaleCode () {
      return this.$i18n.locale
    }
  },
  async mounted () {
    console.log(this.$i18n.messages, 'messages')
    this.initialize()
  },
  methods: {
    changeLanguage (locale) {
      Remember.locale = locale
      this.$i18n.locale = Remember.locale
      changeLanguage(locale)
      location.reload()
    },
    resetDialog () {
      this.naVSubDialogOpen = false
      this.naVDialogOpen = false
      this.activeItem = null
    },
    startShepherd (guideTour, step) {
      guideTour.addStep(step)
      console.log(guideTour, 'tour')
      guideTour.show(2)
    },
    ...mapMutations(['showProductDetail']),
    async initialize () {
      this.resetDialog()
      const allActiveProduct = await getActiveProductCode()
      await this.checkProductLocked(this.navItems, allActiveProduct)
      this.loading = false
    },
    async checkProductLocked (arr, activeProducts) {
      for (const n of arr) {
        n.locked = n.authCode ? !activeProducts.includes(n.authCode) : false
        if (n.children) {
          await this.checkProductLocked(n.children, activeProducts)
        }
      }
    },
    activeCurrentNavBarItem (category, mouseMoveOn) {
      if (this.activeItem?.title === category.title) {
        this.activeItem = null
        return
      }
      if (!category.locked) {
        this.activeItem = category
        this.naVDialogOpen = true
        this.naVSubDialogOpen = true
      } else {
        if (!mouseMoveOn) {
          console.log(category.authCode)
          if (category.authCode) {
            this.showProductDetail({ code: category.authCode })
          }
        }
        if (!category.children) {
          this.naVDialogOpen = false
          this.naVSubDialogOpen = false
        }
      }
    },
    async goto (item, groupPath) {
      item.loading = true
      if (item.locked) {
        this.showProductDetail({ code: item.authCode })
      } else {
        let path = [groupPath, item.to].join('/')
        const ready = item.readyCode ? await productIsReadyForStore(item.readyCode) : true
        if (!ready) {
          path = productActivatePage(item.readyCode)
        }
        console.log(path)
        if (path) {
          if (this.$route.path !== path) {
            item.loading = false
            await (this.$router.push(path))
          }
        }
      }
      item.loading = false
      this.naVDialogOpen = false
      if (this.naVSubDialogOpen) {
        this.naVSubDialogOpen = false
      }
      this.activeItem = null
    }
  }
}
</script>

<style lang="scss">

#navSubDialogContainer {
  height: auto;
  background: #f3f6fc !important;
  border-radius: 18px !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-right: 1px solid transparent !important;
}

.paReset {
  z-index: auto !important;
}

#navDialogContainer {
  top: 0;
  position: fixed;
  width: 320px;
  left: 0;
  z-index: 2;
  height: 100vh;
  background: #f3f6fc !important;
  border-radius: 18px !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-right: 1px solid rgba(17, 17, 17, 0.2) !important;
  -webkit-box-shadow: 15px 0px 15px -24px !important;
  box-shadow: 15px 0px 15px -24px !important;
}

.listItemStyle .v-list-item {
  padding-right: 16px !important;
  padding-left: 16px !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  color: #001d35;
  border-radius: 9999px;
}

.listItemStyle .v-list-item:before {
  border-radius: 9999px !important;
}

.backBtn span {
  -webkit-box-pack: left !important;
  -ms-flex-pack: left !important;
  justify-content: left !important;

}

#shadowRoot {
  position: fixed;
  width: 100%;
  height: 100vh;
  background: #1117;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
  box-shadow: 0 0 1000px #1114 inset;
  opacity: 0;
  transition: .2s ease-in-out;
  pointer-events: none;
  visibility: hidden;
}

.navActivItem .v-list-item {
  color: #f1f1f1 !important;
  background: #3E3E3EFF !important;
  text-shadow: 0 0 1px #fff !important;
}

</style>
